<template>
  <div class="item-parameter">
    <!-- {{datamodel.value}} -->
    <div class="key">
      <span>
      {{key}}
      </span>
    </div>
    <div class="value">
      <span>
        {{value}}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  uuid: "00000000-0000-0000-0000-000000100013",
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    key() {
      return this.datamodel.value && this.datamodel.value.key
      // let valueComponet = this.datamodel.value.filter(item => {
      //   return item.key == 'key'
      // }) 
      // return valueComponet[0] && valueComponet[0].value || ""
    },
    value() {
      return this.datamodel.value && this.datamodel.value.value
      // let valueComponet = this.datamodel.value.filter(item => {
      //   return item.key == 'value'
      // }) 
      // return valueComponet[0] && valueComponet[0].value || ""
    }
  },
  methods: {
    
  },
  created() {},
  mounted() {
    console.log("this.datamodel", this.datamodel)
  }
}
</script>
<style lang="scss" scoped>

.item-parameter {

  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  // margin: 0;
  min-height: 38px;
  display: flex;
  flex: 1;
  // width: calc(100% - 60px);
  .key {
    width: 119px;
    color: #8C8C8C;
    border: 1px solid #F2F2F2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      margin: 16px;
    }
  }
  .value {
    flex: 1;
    color: #000000;
    border: 1px solid #F2F2F2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    word-wrap: break-word;
    word-break: keep-all;

    span {
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 16px;
    }
  }

}
</style>
